<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  props: ['chartdata', 'options'],
  methods: {
    render() {
      this.renderChart(this.chartdata, this.options);
    },
  },
  mounted() {
    this.render();
  },
};
</script>

<style>
</style>
